var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAudioOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23544 0V12H6.58835L3.29418 8.8V3.2L6.58835 0H8.23544ZM12.1915 1.75704C13.3585 2.89064 14 4.39784 14 6.00023C14 7.60264 13.3585 9.10904 12.1915 10.2426L11.6093 9.67704C12.6206 8.69544 13.1765 7.38904 13.1765 6.00024C13.1765 4.61064 12.6206 3.30504 11.6093 2.32264L12.1915 1.75704ZM2.47064 3.2V8.8H1.23532C0.551775 8.8 0 8.264 0 7.6V4.4C0 3.736 0.551775 3.2 1.23532 3.2H2.47064ZM10.4471 3.4556C11.1455 4.1428 11.5293 5.0468 11.5293 5.9996C11.5293 6.9532 11.1455 7.8572 10.4471 8.5444L9.86161 7.9836C10.406 7.446 10.7057 6.7412 10.7057 5.9996C10.7057 5.2588 10.406 4.554 9.86161 4.0164L10.4471 3.4556Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioOn);
export default __webpack_public_path__ + "static/media/icon_audio_on.3c6c96f9e1291177e04290aee5970977.svg";
export { ForwardRef as ReactComponent };